import React, { useEffect, useState } from "react";
import BarChartIcon from "@mui/icons-material/BarChart";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { managerAxios } from "../../axiosInstance";
import loader from "../../assets/loader.webp";
import TopSales from "./TopSales";
import SalesSummary from "./SalesSummary";
import LowStockHome from "./LowStockHome";
import { Link } from "react-router";
import useDefaultCurrency from "../../utility/useDefaultCurrency";
import { formatNumbersWithDecimal } from "../../components/formatNumbersWIthDecimal";
import LowstockChart from "./LowstockChart";

function Home() {
  const { data, error } = useDefaultCurrency("manager");
  const [currency, setCurrency] = useState(null);
  const [overviewData, setOverviewData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = async () => {
    try {
      const response = await managerAxios.get("dashboard");
      setOverviewData(response?.data?.data || {});
    } catch (err) {
      console.log("Error fetching data", err);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setCurrency(data?.currency?.symbol);
  }, [data]);

  if (isLoading) {
    return (
      <div className="w-full h-screen  flex justify-center items-center">
        <img src={loader} alt="loader" className=" w-10 lg:w-20 " />
      </div>
    );
  }
  return (
    <div className="flex flex-col-reverse lg:justify-between gap-5 lg:flex-row bg-[#F0F1F3]">
      <div className="flex flex-col gap-6 lg:w-4/5 ">
        <div className="flex flex-col bg-white rounded-lg gap-6 p-4">
          <h3 className="text-2xl font-medium ">Sales Overview</h3>
          <div className="flex flex-col lg:flex-row gap[20%] gap-4 justify-between">
            <div className="flex flex-col gap-1 items-center bg">
              <BarChartIcon
                className="text-[#629FF4] "
                sx={{ fontSize: "40px" }}
              />
              <div className="flex font-medium text-lg flex-row gap-3">
                <h3>{overviewData?.lowStockCount}</h3>
                <h3>Low stock count</h3>
              </div>
            </div>
            <div className="flex flex-col gap-1  items-center bg">
              <LocalAtmIcon
                className="text-[#629FF4]"
                sx={{ fontSize: "40px" }}
              />
              <div className="flex gap-3 font-medium text-lg  flex-row ">
                <h3>
                  {currency}
                  {formatNumbersWithDecimal(overviewData?.todaysTotalRevenue)}
                </h3>
                <h3>Revenue</h3>
              </div>
            </div>
            <div className="flex flex-col gap-1 items-center bg">
              <TrendingUpIcon
                className="text-[#629FF4]"
                sx={{ fontSize: "40px" }}
              />
              <div className="flex gap-3 font-medium text-lg  flex-row ">
                <h3>{overviewData?.todaysSalesCount}</h3>
                <h3>Today's sales</h3>
              </div>
            </div>
          </div>
        </div>

        {/* Sales Summary Chart */}
        <SalesSummary />

        {/*Low Stock Chart */}
        {/* <LowstockChart /> */}

        <div className="flex flex-col bg-white rounded-lg gap-6 p-4 ">
          <div className="flex justify-between">
            <h3 className="text-2xl font-medium ">Top Sales</h3>
            <Link to="sales">
              <button className=" text-lg text-blue-500 hover:text-blue-600">
                See All
              </button>
            </Link>
          </div>
          <div className="overflow-x-scroll">
            <table className="min-w-full bg-white border border-gray-300 ">
              <thead>
                <tr className="bg-gray-200">
                  <th className="py-2 px-4 border-b border-gray-300">
                    ORDER NUMBER
                  </th>
                  <th className="py-2 px-4 border-b border-gray-300">
                    CASHIER NAME
                  </th>
                  {/* <th className="py-2 px-4 border-b border-gray-300">
                    QUANTITY SOLD
                  </th> */}
                  <th className="py-2 px-4 border-b border-gray-300">STATUS</th>
                  <th className="py-2 px-4 border-b border-gray-300 text-wrap">
                    PRICE
                  </th>
                </tr>
              </thead>

              <TopSales currency={currency} />
            </table>
          </div>
        </div>
      </div>
      <div className="flex flex-grow flex-col bg-white rounded-lg  gap-6 p-3">
        <h3 className="text-2xl font-medium ">Low Stock</h3>
        <LowStockHome />
      </div>
    </div>
  );
}

export default Home;
